import { render, staticRenderFns } from "./XDiseaseCollection.vue?vue&type=template&id=a7c65bf6&scoped=true"
import script from "./XDiseaseCollection.vue?vue&type=script&lang=js"
export * from "./XDiseaseCollection.vue?vue&type=script&lang=js"
import style0 from "./XDiseaseCollection.vue?vue&type=style&index=0&id=a7c65bf6&prod&scoped=true&lang=css"
import style1 from "./XDiseaseCollection.vue?vue&type=style&index=1&id=a7c65bf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c65bf6",
  null
  
)

export default component.exports